(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("muster", [], factory);
	else if(typeof exports === 'object')
		exports["muster"] = factory();
	else
		root["muster"] = factory();
})(window, function() {
return 